import React, { Component } from "react";
import { Row, Col } from "antd";
import {
  parseFormControlValue,
  checkEmptyObject
} from "../../../services/utils";
import styles from "./multiColorSelector.scss";

const defaultSettings = {
  responsiveProps: {
    xs: 6,
    sm: 6
  }
};

// Not in use
class MultiColorSelector extends Component {
  onChange = event => {
    const { onChange, field } = this.props;
    const value = this.getValue();
    const targetValue = parseInt(event.target.value, 10);
    const targetValueIndex = value.indexOf(targetValue);
    const newSelectedValues = value.slice();

    if (targetValueIndex > -1) {
      newSelectedValues.splice(targetValueIndex, 1);
    } else {
      newSelectedValues.push(targetValue);
    }

    const result =
      newSelectedValues.length === 0
        ? { [field]: undefined }
        : parseFormControlValue([field], [newSelectedValues]);

    onChange(result);
  };

  getValue() {
    const { value, field } = this.props;

    return checkEmptyObject(value) && value[field] ? value[field] : [];
  }

  render() {
    const { options, title, settings } = this.props;
    const value = this.getValue();

    return (
      <React.Fragment>
        {title ? <span className="control-title">{title}</span> : null}
        <Row>
          {options.map((option, index) => (
            <Col
              key={index /* eslint-disable-line */}
              {...settings.responsiveProps}
            >
              <label title={option.title} className={styles.container}>
                <input
                  onChange={this.onChange}
                  type="checkbox"
                  value={option.value}
                  defaultChecked={value.includes(option.value)}
                />
                <span
                  className={styles.checkmark}
                  style={{ backgroundColor: option.color }}
                />
              </label>
            </Col>
          ))}
        </Row>
      </React.Fragment>
    );
  }
}

MultiColorSelector.defaultProps = {
  settings: defaultSettings,
  title: "",
  onChange: () => null
};

export default MultiColorSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiColorSelector/MultiColorSelector.js